import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  public isOpen$ = this.isOpenSubject.asObservable();

  private isMobileSubject = new BehaviorSubject<boolean>(false);
  public isMobile$ = this.isMobileSubject.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.checkScreenSize();
      window.addEventListener('resize', () => this.checkScreenSize());
    }
  }

  private checkScreenSize(): void {
    const isMobile = window.innerWidth <= 768;
    this.isMobileSubject.next(isMobile);

    // El sidebar siempre inicia cerrado, independientemente del tamaño de pantalla
  }

  public toggle(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  public open(): void {
    this.isOpenSubject.next(true);
  }

  public close(): void {
    this.isOpenSubject.next(false);
  }

  public get isOpen(): boolean {
    return this.isOpenSubject.value;
  }

  public get isMobile(): boolean {
    return this.isMobileSubject.value;
  }
}
